<script setup lang="ts">
import type { ProductModel } from '@/types/models/ProductModel'
import {
    BaseDialog,
    SelectorField,
    StackLayout,
    StringInputField
} from '@rfc/rfc-components-library'
import ProductTemplateSelectors from './ProductTemplateSelectors.vue'
import { EEncoding, EEncodingOptions } from '../../../types/enum/EncodingEnum.js'

type Props = {
    open: boolean
    data: Partial<ProductModel>
}
defineProps<Props>()
type Emits = {
    (e: 'close'): void
    (e: 'confirm'): void
    (e: 'change', data: Partial<ProductModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <BaseDialog
        :open="open"
        :disabled="!data.name"
        :title="`${$t('common.edit')} — ${data?.name}`"
        @confirm="$emit('confirm')"
        @close="$emit('close')">
        <StackLayout direction="column" :gap="8">
            <StringInputField
                :modelValue="data.name"
                @change="$emit('change', { name: $event })"
                :label="$t('products.model.name')"
                required />
            <SelectorField
                :modelValue="data.encoding"
                :options="EEncodingOptions"
                @change="$emit('change', { encoding: $event as EEncoding })"
                :label="$t('products.model.encoding')" />
            <ProductTemplateSelectors :data="data" @change="$emit('change', $event ?? {})" />
        </StackLayout>
    </BaseDialog>
</template>
